import React, { useState, useEffect } from 'react'
import { PhoneNumberUtil, PhoneNumberType } from 'google-libphonenumber'

const ContactInformationSection = ({
  profileData,
  setProfileData,
  userInfo,
  setUserInfo,
  onValidityChange,
  showTitle = true,
}) => {
  const [phoneError, setPhoneError] = useState('')

  const phoneUtil = PhoneNumberUtil.getInstance()

  const validatePhoneNumber = (value) => {
    try {
      const parsedNumber = phoneUtil.parse(value, 'GB')

      const isValidForRegion = phoneUtil.isValidNumberForRegion(
        parsedNumber,
        'GB'
      )

      const isMobile =
        phoneUtil.getNumberType(parsedNumber) ===
        PhoneNumberType.MOBILE

      return isValidForRegion && isMobile
    } catch {
      return false
    }
  }

  useEffect(() => {
    const value = profileData?.phone_number || ''

    if (!value) {
      onValidityChange?.(false)
      return
    }

    const valid = validatePhoneNumber(value)
    onValidityChange?.(valid)
  }, [profileData?.phone_number])

  const handlePhoneChange = (event) => {
    let value = event.target.value

    // Allow only digits and +
    value = value.replace(/[^\d+]/g, '')

    // Only allow + at the start
    if (value.includes('+')) {
      value = '+' + value.replace(/\+/g, '')
    }

    // Limit length
    if (value.startsWith('+44')) {
      value = value.slice(0, 13)
    } else {
      value = value.slice(0, 11)
    }

    setProfileData((prev) => ({
      ...prev,
      phone_number: value,
    }))

    const digitCount = value.replace(/\D/g, '').length

    // Don't show validation errors while typing
    if (digitCount < 11) {
      setPhoneError('')
      return
    }

    const valid = validatePhoneNumber(value)

    setPhoneError(
      valid ? '' : 'Please enter a valid UK mobile number'
    )
  }

  const handlePhoneBlur = () => {
    const value = profileData?.phone_number

    if (!value) {
      setPhoneError('')
      return
    }

    const valid = validatePhoneNumber(value)

    setPhoneError(
      valid ? '' : 'Please enter a valid UK mobile number'
    )
  }

  return (
    <>
      {showTitle && (
        <div className="sm:col-span-6">
          <h2 className="text-xl font-medium">
            Contact Information
          </h2>
        </div>
      )}

      <div className="sm:col-span-3">
        <label
          htmlFor="email-address"
          className="block text-sm/6 font-medium"
        >
          Email address
        </label>

        <input
          id="email-address"
          name="email-address"
          value={profileData?.email || ''}
          onChange={(event) =>
            setProfileData((prev) => ({
              ...prev,
              email: event.target.value,
            }))
          }
          type="email"
          autoComplete="email"
          className="mt-2 block w-full rounded-md bg-white px-3 py-1.5 text-base border border-gray-300 placeholder:text-gray-400 focus:border-violet-300 focus:ring-1 focus:ring-violet-300 focus:outline-none sm:text-sm/6"
        />
      </div>

      <div className="sm:col-span-3">
        <label
          htmlFor="phone-number"
          className="block text-sm/6 font-medium"
        >
          Phone number
        </label>

        <input
          id="phone-number"
          name="phone-number"
          value={profileData?.phone_number || ''}
          onChange={handlePhoneChange}
          onBlur={handlePhoneBlur}
          type="tel"
          inputMode="numeric"
          autoComplete="tel"
          placeholder="07123456789"
          className={`mt-2 block w-full rounded-md bg-white px-3 py-1.5 text-base border placeholder:text-gray-400 focus:border-violet-300 focus:ring-1 focus:ring-violet-300 focus:outline-none sm:text-sm/6 ${
            phoneError
              ? 'border-red-500'
              : 'border-gray-300'
          }`}
        />

        {phoneError && (
          <p className="mt-1 text-sm text-red-600">
            {phoneError}
          </p>
        )}
      </div>
    </>
  )
}

export default ContactInformationSection